import styled, {keyframes} from 'styled-components';


const fontTitle = "Raleway"
const fontContent = "Open sans"
type ButtonRefStateProps = {
    color: string,
    active: boolean
    background?: string
}


export const ProductContainer = styled.div`
    display: flex;
    padding: 2.5em;
    font-family: ${fontContent};
    @media (max-width: ${props => props.theme.breakpoints.md}){
        flex-direction: column;
        padding: 0em 0em 0.5em 0em;
        background: white;
    }
`

export const LoadContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 60vh;
`

export const ProductImages = styled.div`
    display: flex;
    width: 100%;
    height: 100%;
    
`
type Cwidth ={
    currentWidth?:number
}


export const ProductImageSlider = styled.div<Cwidth>`
    display: none;
    overflow:hidden;
    max-width: ${props => props.theme.breakpoints.md};
    display: block;
    /* max-height: 320px; */
    .slick-slide img {
        overflow:hidden;
        position: relative;
        flex-grow: 0;
        flex-shrink: 0;
        align-self: stretch;
        /* dynamic height proportion with the current width*/
        height: calc(${props => props.currentWidth}px/1.5);
        /* static height*/
        /* height: 350px; */
    }



    .slick-prev{
        opacity:.4;
        position:absolute;
        width:25px;
         height:50px;
         background-color:#000;
         display:block;
         top: calc(60% - 15px);
         left: 20px;
         z-index:2;
    }
 
        

    .slick-next {
        opacity:.4;
        position:absolute;
        width:25px;
         height:50px;
         background-color:#000;
         display:block;
         right:0px;
         top: calc(60% - 15px);
         right: 20px;
        
    }


    .slick-next::after{
        content: '';
        width: 20px;
        height: 20px;
        position: absolute;
        top:14px;
        border-bottom: 2px solid;
        border-left: 2px solid;
        z-index: 1000000;
        cursor: pointer;
        border-color: #fff;
        -webkit-transform: rotate(-135deg);
        -ms-transform: rotate(-135deg);
        transform: rotate(-135deg);
        right: 8px;
         
    }

    .slick-prev::after{
        content: '';
        width: 20px;
        height: 20px;
        position: absolute;
        top:14px;
        border-bottom: 2px solid;
        border-left: 2px solid;
        z-index: 1000000;
        cursor: pointer;
        border-color: #fff;
        -webkit-transform: rotate(45deg);
        -ms-transform: rotate(45deg);
        transform: rotate(45deg);
        right: -5px;
         
    }
    .slick-prev::before{
        content: '';
    }

    .slick-next::before{
        content: '';
    }
`


export const ProductImagesList = styled.div`

    display: flex;    
    flex-direction: column;
    margin-right: 2.5em;
    height: fit-content;
    /* display: grid;
    grid-template-rows: repeat(5, 1fr);
    grid-auto-flow: column;
    grid-auto-rows: 31.90vh;
    grid-auto-columns: 6vw; */

    .normal-image{
        margin: 0em 0em 1.5em 0em;
        max-width: 100px;
        max-height: 100px;
        width:  6vw;
        height: 8vh;
        object-fit: cover;
    }

    .selected-image{
        box-shadow: 10px 5px 5px gray;
        margin: 0em 0em 1.5em 0em;
        max-width: 100px;
        max-height: 100px;
        width:  6vw;
        height: 8vh;
        object-fit: cover;
    }
    & img {
        cursor: pointer;
    }

    
`

const fadeEffect = keyframes`
    from {
        opacity: 0;
    }

    to {
        opacity: 1;
    }
`

export const ProductImageMain = styled.div`

    overflow: hidden; /* [1.2] Hide the overflowing of child elements */
    position: relative;
    display: flex;
    border-radius: 0px; 
    img {
        cursor: pointer;
        max-width: 660px;
        max-height: 660px;
        width: 100%!important;
        height: 100%;
        object-fit: cover;
        transition: all 1s ease;
        animation: ${fadeEffect} 1s ease;
    }

    @media (min-width: 992px){
        div {
            border-radius:10px;
        }
        img {
            border-radius:10px!important;

        }
    }


    

    @media (max-width: ${props => props.theme.breakpoints.md}){
        img {
            max-width: ${props => props.theme.breakpoints.md};
        }
    }

    

    
`



export const ProductData = styled.div`
    display: flex;
    flex-direction: column;
    width: 75%;
    height: 100%;
    padding-left: 1.5em;

    .product-data-title{
        display: flex;
        justify-content: space-between;
        font-family: ${fontTitle};
        font-size: 30px;
        font-weight: bold;
        @media (max-width: ${props => props.theme.breakpoints.md}){
            font-weight: 400;
        }

        button>div>svg {
            width: 45px;
            height: 27px;
        }
    }

    .product-data-sales{        
        margin: 0.5em auto;
        width: 100%;
        display: flex;
        flex-direction: row;
        border-bottom: 2px solid #F6F6F6;
        /* &:after{
            content: "";
            width: 100%;
            height: 2px;
            background: #F6F6F6;
        } */
    }
    .product-data-price{
        font-size: 30px;
        display: flex;
        flex-direction: column;
        align-items: center;
        align-items: flex-start;
        @media (max-width: ${props => props.theme.breakpoints.md}){
            font-weight: bold;
        }
    }
    .product-mainPrice{
        font-size: 30px;
        font-weight: 400;        
    }

    .product-data-discountPrice{
        font-size: 16px;
        font-weight: 400;
        color: rgba(153, 153, 153, 1);
        text-decoration: line-through;

    }
    .ml-2 {
        margin-left: 2rem;
    }

    .mt-2 {
        margin-top: 2rem;
    }

    .product-data-description{
        margin-top: 0.75em;
        font-size: 16px;
        font-weight: 400;
        color: #444444;
        text-align: justify;
    }
    .product-data-quantity{
        font-size: 16px;
        font-weight: 700;
        p{
            margin-bottom: 0.5em;
        }
        & > .product-data-quantity-availability{
            font-family: 'Open Sans';
            font-weight: 600;
            font-size: 14px;
            color: rgba(153,153,153,1);
        }
    }
    .product-data-pickup{
        & > p{
            font-weight: 700;
            margin-bottom: 10px;
            margin-top: 10px;
            & span {
                color: rgba(153,153,153,1);
            }
        }
        & h5{
            margin: 0px;
            display: flex;
            align-items: center;
            cursor: pointer;
        }
    }
    
    
    .product-data-totalPrice{
        margin-top: 4em;
        font-size: 16px;
        font-weight: 700;
        .product-data-totalText{
            
        }
        .product-data-totalAmount{
            font-size: 2.1em;
        }
    }
    .product-data-buttons{
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        * {
            flex: 1;
            padding-inline: 0;
        }
        @media (max-width: ${props => props.theme.breakpoints.md}){
            width: 100vw !important;
            margin: 0;
            position: fixed;
            bottom: 0;
            left: 0;
            right: 0;
            margin-bottom: 50px;
            z-index: 10001;
            * {
                padding: .75rem 0rem;
                margin: 0px;
                border-radius: 0;
                flex: 1;
            }  
        }
    }

    .product-data-references{
        flex-direction: row;
        justify-content: space-between;     
        align-items: center;
        & > .product-data-references-button{
            padding-inline: 0.5rem;
            margin: 0.25rem;
        },
        * {
            flex: 1;
            padding-inline: 0;
        },


        @media (max-width: ${props => props.theme.breakpoints.md}){
            margin: 0;
            position: fixed;
            bottom: 0;
            left: 0;
            right: 0;
            margin-bottom: 50px;
            z-index: 10001;
            * {
                padding: .75rem 0rem;
                margin: 0px;
                border-radius: 0;
                flex: 1;
            }  
        }
    }
    /* .product-data-title{}
    .product-data-title{} */

    @media (max-width: ${props => props.theme.breakpoints.md}){
        padding: 1.5em;
        width: auto;
    }

`

export const ReferenceOther = styled.button<ButtonRefStateProps>`
    min-width: 2.5rem;
    padding-top: 0.7rem;
    padding-bottom: 0.7rem;
    margin-right: 1rem;
    border: 2px solid #E2E2E2;
    background: #ffffff;
    border-radius: 3px;
    cursor: pointer;
    :first-letter {
        text-transform: uppercase;
    }

    :hover {
        border: 2px solid ${props => props.color};
    }
    :focus {
        outline: none;
    }
    ${(props) => {
        if (props.active)
        return `border: 3px solid ${props.color};`    
    }}


`


export const UnavailableProduct = styled.div`
display:flex;
justify-content:center;
text-align:center;
border:2px solid darkgray;
padding:1rem;
border-radius:5px;
color:darkgray;
font-weight:bold;
margin-top:3rem;
`;

export const ReferenceColor = styled.button<ButtonRefStateProps>`
    min-width: 2.2rem;
    padding-top: 0.9rem;
    padding-bottom: 0.9rem;
    margin-right: 1rem;
    border: 2px solid #E2E2E2;
    background: ${props => props.background ? props.background : '#ffffff'};
    border-radius: 3px;
    cursor: pointer;
    :first-letter {
        text-transform: uppercase;
    }

    :hover {
        border: 2px solid ${props => props.color};
    }
    :focus {
        outline: none;
    }
    ${(props) => {
        if (props.active)
        return `border: 3px solid ${props.color};`    
    }}


`
    